module.exports = __webpack_public_path__ + "static/media/maggie.d825e641.jpg";